
























import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class EditableCell extends Vue {
  @Prop({ default: () => [] }) private readonly options!: Array<any>
  @Prop({ default: () => [] }) private schools!: Array<any>

  private editable = false
  private id = []
  private value = ''
  // private school: Array<any> = cloneDeep(this.schools)

  @Watch('schools', { immediate: true })
  private onSchoolIdsChange(newVal): void {
    this.id = newVal.map(item => item['schoolId'])
    this.value = newVal.map(item => item.name).join(', ')
  }

  private check(): any {
    this.editable = false
    this.value = this.schools.map(item => item.name).join(', ')
    this.change()
  }

  @Emit('change')
  private change(): Array<number> {
    return this.id
  }

  private edit(): void {
    this.editable = true
  }
}
